import { Injectable } from "@angular/core";
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from 'rxjs/Observable';
//import { BehaviorSubject } from 'rxjs/Rx';
import { SERVER, LOGON_INFO } from "../app.constants";
import { SafeUrl } from "@angular/platform-browser";


@Injectable()
export class CarService {

    //allCarList: BehaviorSubject<any> = new BehaviorSubject<any>(undefined);
    //allCarList: Car[];

    KEY__CAR_REGIST_YEAR_LIST: string = "car_regist_year_list";
    KEY__CAR_LIST: string = "car_list";
    KEY__DISPATCH_TARGET_CAR_LIST: string = "dispatch_target_car_list";

    PDF_ITEM_NAMES = ["inspection_pdf", "inspection_license_pdf", "insurance_pdf", "insurance_option_pdf", "weight_check_pdf"];

    constructor(
        private _htc: HttpClient
    ) { }

    //所属営業所の車両リスト取得(paging, 1page100件まで)
    getCarList(page: number, isDeleteCar: boolean): Observable<Car[]> {
        let params = new HttpParams().set('page', page.toString());
        return this._htc.get<Car[]>(SERVER.baseURL+'/car-list/'+LOGON_INFO.COMP_ID+'/'+isDeleteCar.toString()+'/false/', {params: params});
    }

    // //全営業所の車両リスト取得(paging, 1page500件まで)
    getAllBranchCarList(page: number, isDeleteCar: boolean): Observable<Car[]> {
        let params = new HttpParams().set('page', page.toString());
        return this._htc.get<Car[]>(SERVER.baseURL+'/car-list-all/'+LOGON_INFO.PARENT_COMP_ID+'/'+isDeleteCar.toString()+'/true/'+LOGON_INFO.USER_ID, {params: params});
    }

    //全営業所の車両リストをsessionStorageへ保存
    getAllCarList() {
        return JSON.parse(sessionStorage.getItem(this.KEY__CAR_LIST));                  //車両管理用車両リスト
    }
    getDispatchTargetCarList() {
        return JSON.parse(sessionStorage.getItem(this.KEY__DISPATCH_TARGET_CAR_LIST));  //配車用車両リスト
    }

    fetchAllCarList(): Promise<any> {
        return new Promise((resolve, reject) => {
            let params = new HttpParams().set('page', '1');
            this._htc.get<Car[]>(SERVER.baseURL+'/car-list-all/'+LOGON_INFO.PARENT_COMP_ID+'/false/true/'+LOGON_INFO.USER_ID, {params: params})
                .subscribe(
                    data => {
                        let allCarList: any[] = [];
                        const dispatchCarList: any[] = [];
                        let allCarRegistYear: any[] = [];
                        console.log('data?!', data);

                        if (data['results'] && data['results'].length > 0) {
                            let comp_idx = 0;
                            let car_idx = 0;
                            let before_comp_id = "";

                            for(let i=0; i<data['results'].length; i++) {
                                ////// * 配車車両リストの編集
                                let car = Object.assign({}, data['results'][i]);
                                if (i > 0) {
                                    if (car.comp_id != before_comp_id) {
                                        comp_idx++;
                                        car_idx = 0;
                                    } else {
                                        car_idx++;
                                    }
                                }
                                car.comp_idx = comp_idx;
                                car.car_idx = car_idx;
                                car.comp_car_cnt = data['results'].filter((obj) => obj.comp_id == car.comp_id).length;
                                car.car_no = car.car_no_first + car.car_no_last;
                                car.car_ton = car.max_load_weight ? Math.floor(car.max_load_weight / 100) / 10 : 0;
                                before_comp_id = car.comp_id;
                                dispatchCarList.push(car);
                            }

                            this.convertCarInfo(data['results'], allCarList, allCarRegistYear);
                        }

                        sessionStorage.setItem(this.KEY__CAR_LIST, JSON.stringify(allCarList));
                        sessionStorage.setItem(this.KEY__CAR_REGIST_YEAR_LIST, JSON.stringify(allCarRegistYear));
                        sessionStorage.setItem(this.KEY__DISPATCH_TARGET_CAR_LIST, JSON.stringify(dispatchCarList));

                        resolve(null);
                    }
                    ,error => {
                        reject(null);
                    }
                );
        });
    }


    convertCarInfo(data_list: any, car_list: Car[], registYm_list: any[]): void {
        for(let i=0; i<data_list.length; i++) {
            const car2: Car = Object.assign({}, data_list[i]);

            ////// * 車両リストデータの編集
            car2.car_no = car2.car_no_first + car2.car_no_last.toString().padStart(4,'･');
            car2.regist_ym_1 = car2.regist_ym.substr(0, 2);
            car2.regist_ym_2 = car2.regist_ym.substr(2, car2.regist_ym.indexOf("年") - 2);
            car2.regist_ym_3 = car2.regist_ym.substr(car2.regist_ym.indexOf("年") + 1).replace('月','');
            car2.car_photos_path = [];
            car2.car_photos_path_new = [];
            car2.car_photos_file = [];
            car2.is_print_target = false;
            car_list.push(car2);

            ////// * 年式リスト（combobox用）の編集
            const registYear = car2.regist_ym_1 + car2.regist_ym_2 + "年";
            if (!registYm_list.some((e: any) => e.code == registYear)) {
                registYm_list.push({
                    code: registYear,
                    name: registYear,
                    order_1: car2.regist_ym_1 == "昭和" ? '1' : (car2.regist_ym_1 == "平成" ? '2' : '3'),
                    order_2: car2.regist_ym_2.padStart(2,'0'),
                    // (2024.02)マルチセレクト対応
                    is_selected: false
                });
            }
            registYm_list = registYm_list.sort((a,b) => {
                return a.order_1 + a.order_2 > b.order_1 + b.order_2 ? 1 : -1;
            });
        }
    }


    // fetchGroupAllCarList(): Promise<any> {
    //     return new Promise((resolve, reject) => {
    //         let params = new HttpParams().set('page', '1');
    //         this._htc.get<Car[]>(SERVER.baseURL+'/group-car-list/'+LOGON_INFO.PARENT_COMP_ID+'/', {params: params})
    //             .subscribe(
    //                 data => {
    //                     if (data['results'] && data['results'].length > 0) {
    //                         let comp_idx = 0;
    //                         let car_idx = 0;
    //                         let before_comp_id = "";

    //                         for(let i=0; i<data['results'].length; i++) {
    //                             if (i > 0) {
    //                                 if (data['results'][i].comp_id != before_comp_id) {
    //                                     comp_idx++;
    //                                     car_idx = 0;
    //                                 } else {
    //                                     car_idx++;
    //                                 }
    //                             }

    //                             data['results'][i].comp_idx = comp_idx;
    //                             data['results'][i].car_idx = car_idx;
    //                             data['results'][i].comp_car_cnt = data['results'].filter((obj) => obj.comp_id == data['results'][i].comp_id).length;

    //                             before_comp_id = data['results'][i].comp_id;
    //                         }
    //                     }

    //                     sessionStorage.setItem("all_group_car_list", JSON.stringify(data['results']));
    //                     resolve(null);
    //                 }
    //                 ,error => {
    //                     reject(null);
    //                 }
    //             );
    //     });
    // }

    getCar(car_id: number): Observable<Car[]> {
        return this._htc.get<Car[]>(SERVER.baseURL+'/car-info/'+car_id+'/');
    }

    //指定半径内の車両リスト取得
    getRadiusCarList(lat:number, lng:number, radius:number): Observable<Car[]> {
        let params = new HttpParams().set('lat', lat.toString()).append('lng', lng.toString()).append('radius', radius.toString());
        return this._htc.get<Car[]>(SERVER.baseURL+'/car-radius/'+LOGON_INFO.COMP_ID+'/', {params: params});
    }

    //車両番号重複チェック
    isCarnoDuplicate(carno: string, currend_car_id: number): boolean {
        let carList = this.getAllCarList();
        for (var i=0; i<carList.length; i++) {
            //更新対象車両は比較対象外
            if (!currend_car_id || currend_car_id != carList[i].id) {
                if (carList[i].car_no_first + carList[i].car_no_last == carno) {
                    return true;
                }
            }
        }
        return false;
    }

    //車台番号重複チェック
    isBodyNoDuplicate(body_no: string, currend_car_id: number): boolean {
        let carList = this.getAllCarList();
        for (var i=0; i<carList.length; i++) {
            //更新対象車両は比較対象外
            if (!currend_car_id || currend_car_id != carList[i].id) {
                if (carList[i].body_no == body_no) {
                    return true;
                }
            }
        }
        return false;
    }

    //車両新規登録
    registCar(car: Car): Observable<Car> {
        car.parent_comp_id = LOGON_INFO.PARENT_COMP_ID;
        car.create_id = LOGON_INFO.USER_ID;
        car.update_id = LOGON_INFO.USER_ID;
        return this._htc.post<Car>(SERVER.baseURL+'/car-regist/', this.getInuptFormData(car));
    }

    //車両情報を更新
    updateCar(car: Car): Observable<Car> {
        car.parent_comp_id = LOGON_INFO.PARENT_COMP_ID;
        car.update_id = LOGON_INFO.USER_ID;
        return this._htc.put<Car>(SERVER.baseURL+'/car-update/'+car.id+'/', this.getInuptFormData(car));
    }

    //車両情報削除(論理削除)
    deleteCar(id: number) {
        return this._htc.put<Car>(SERVER.baseURL+'/car-delete/'+id+'/', JSON.stringify({update_id: LOGON_INFO.USER_ID}));
    }

    //車両情報復活(論理削除)
    reviveCar(id: number) {
        return this._htc.put<Car>(SERVER.baseURL+'/car-revive/'+id+'/', JSON.stringify({update_id: LOGON_INFO.USER_ID}));
    }

    //車両位置情報を登録
    registCarLocation(carLocation: CarLocation) {
        carLocation.create_id = LOGON_INFO.USER_ID;
        return this._htc.post<CarLocation>(SERVER.baseURL+'/car-location-regist/', JSON.stringify(carLocation));
    }

    //車両登録年度リストを取得
    getCarRegistYearList() {
        // return this._htc.get<Code[]>(SERVER.baseURL+'/car-regist-year-list/'+LOGON_INFO.PARENT_COMP_ID+'/');
        return JSON.parse(sessionStorage.getItem(this.KEY__CAR_REGIST_YEAR_LIST));
    }

    // PDF Link
    getPdfLinkList(): Promise<any> {
        return new Promise((resolve, reject) => {
            this._htc.get<PdfLink[]>(SERVER.baseURL+'/car-pdf-link/'+LOGON_INFO.USER_ID+'/')
            .subscribe(
                data => {
                    if (data.length) {
                        data[0].create_date = data[0].create_date.slice(0,19).replace('T', '\r\n');
                    }
                    sessionStorage.setItem("pdf_link", JSON.stringify(data));

                    resolve(null);
                }, error => {
                    reject(null);
                }
            )
        })
    }



    // ------ 以下 Private

    //車両情報の登録・更新用の入力Formパラメータを生成
    private getInuptFormData(car: Car) {
        let form_data = new FormData();

        for ( let key in car ) {
            if (key == "placement_date" || key == "inspection_expire_date" || key == "insurance_expire_date" || key == "lease_date" || key == "lease_start_date") {
                form_data.append(key, car[key] ? car[key].formatted.split('/').join('-') : "");
            }
            else if (key == "car_photos_file") {
                if (car.car_photos_file && car.car_photos_file.length > 0) {
                    for (let i=0; i<car.car_photos_file.length; i++) {
                        form_data.append("car_photos_file", car.car_photos_file[i], car.car_photos_file[i].name);
                    }
                }
            }
            else if (key == "car_photos_path") {
                if (car.car_photos_path && car.car_photos_path.length > 0) {
                    for (let i=0; i<car.car_photos_path.length; i++) {
                        form_data.append("car_photos_path", JSON.stringify(car.car_photos_path[i]));
                    }
                }
            }
            // PDFファイル追加
            // else if (key == "inspection_pdf_file") {
            //     if (car.inspection_pdf_file && car.inspection_pdf_file.size > 0) {
            //         form_data.append("inspection_pdf_file", car.inspection_pdf_file, car.inspection_pdf_file.name);
            //     }
            // }
            else if (this.PDF_ITEM_NAMES.some((name: string) => name+"_file" == key)) {
                if (car[key] && car[key].size > 0) {
                    form_data.append(key, car[key], car[key].name);
                }
            }
            // 既存PDFファイル削除
            // else if (key == "inspection_pdf_path") {
            //     if (car.inspection_pdf_path && car.inspection_pdf_path.length > 0) {
            //         for (let i=0; i<car.inspection_pdf_path.length; i++) {
            //             form_data.append("inspection_pdf_path", JSON.stringify(car.inspection_pdf_path[i]));
            //         }
            //     }
            // }
            else if (this.PDF_ITEM_NAMES.some((name: string) => name+"_path" == key)) {
                if (car[key] && car[key].length > 0) {
                    for (let i=0; i<car[key].length; i++) {
                        form_data.append(key, JSON.stringify(car[key][i]));
                    }
                }
            }
            // else if (this.PDF_ITEM_NAMES.some((name: string) => name+"_file" == key)) {
            //     // 削除した場合
            //     if (car[key] == undefined)  form_data.append(key, car[key]);
            //     // 送付した場合
            //     else                        form_data.append(key, car[key], car[key].name);
            // }
            else {
                if (car[key] || car[key] == 0) {
                    form_data.append(key, car[key]);
                } else {
                    form_data.append(key, "");
                }
            }
        }

        form_data.append("regist_ym", car.regist_ym_1 + car.regist_ym_2 + "年" + car.regist_ym_3 + "月");

        return form_data;
    }

}



export class Car {
    id: number;
    parent_comp_id: string;
    group_name: string;
    comp_id: string;
    comp_name: string;
    placement_date: any;
    car_no: string;
    car_no_first: string;
    car_no_last: number;
    car_type: string;
    car_type_name: string;
    model_no: string;
    body_no: string;
    car_maker: string;
    car_maker_name: string;
    regist_ym: string;
    regist_ym_1: string;
    regist_ym_2: string;
    regist_ym_3: string;
    inspection_expire_date: any;
    inspection_expire_date_str: string;
    insurance_expire_date: any;
    owner: string;
    lease_date: any;
    driver_id: number;
    driver_names: string;
    max_load_weight: string;
    car_weight: number;
    car_type_detail: string;
    car_idx: number;
    comp_idx: number;
    comp_car_cnt: number;
    depth: number;
    width: number;
    height: number;
    etc: string;
    status: string;
    distance: number;
    lat: number;
    lng: number;
    create_id: string;
    create_date: Date;
    update_id: string;
    update_name: string;
    update_date: Date;

    //google mapでのinfo表示用
    driver_name: string;
    driver_mobile: string;

    // is_inspection_show: boolean;
    driver_license_type: string;
    driver_license_expire_date: any;
    driver_tel: string;

    //印刷対象有無
    is_print_target: boolean;


    //File input(AWS S3 Path)
    inspection_pdf: string;           //車検証PDF
    inspection_license_pdf: string;   //車検証(免許付き)PDF
    insurance_pdf: string;            //自賠責保険証書PDF
    insurance_option_pdf: string;     //任意保険証書PDF
    weight_check_pdf: string;         //自重計検査票PDF
    car_photos: string;

    //File url path (2024.06)配列に変更
    inspection_pdf_path: any[];           //車検証PDF
    inspection_license_pdf_path: any[];   //車検証(免許付き)PDF
    insurance_pdf_path: any[];            //自賠責保険証書PDF
    insurance_option_pdf_path: any[];     //任意保険証書PDF
    weight_check_pdf_path: any[];         //自重計検査票PDF
    car_photos_path: any[];
    car_photos_path_new: SafeUrl[];

    inspection_pdf_add_path: any;           //新規車検証PDF
    inspection_license_pdf_add_path: any;   //新規車検証(免許付き)PDF
    insurance_pdf_add_path: any;            //自賠責保険証書PDF
    insurance_option_pdf_add_path: any;     //任意保険証書PDF
    weight_check_pdf_add_path: any;         //自重計検査票PDF

    inspection_pdf_path_rev: any[];           //車検証PDF(Reverse)

    //File input
    inspection_pdf_file: File;           //車検証PDF
    inspection_license_pdf_file: File;   //車検証(免許付き)PDF
    insurance_pdf_file: File;            //自賠責保険証書PDF
    insurance_option_pdf_file: File;     //任意保険証書PDF
    weight_check_pdf_file: File;         //自重計検査票PDF
    car_photos_file: File[];

    lease_fee: number;
    lease_balance: number;
    lease_disposal: number;
    lease_withdrawl: number;
    lease_start_date: any;
}


export class CarLocation {
    car_id: number;
    cargo_id: number;
    cargo_status: string;
    lat: number;
    lng: number;
    create_id: string;
    create_date: Date;
}


export class ExcelPrintTarget {
    is_group_name_print: boolean = false;
    is_comp_name_print: boolean = false;
    is_placement_date_print: boolean = false;
    is_car_no_print: boolean = true;
    is_car_type_print: boolean = true;
    is_model_no_print: boolean = true;
    is_body_no_print: boolean = false;
    is_car_maker_print: boolean = true;
    is_regist_ym_print: boolean = true;
    is_inspection_expire_date_print: boolean = true;
    is_insurance_expire_date_print: boolean = false;
    is_owner_print: boolean = false;
    is_lease_date_print: boolean = false;
    is_driver_print: boolean = true;
    is_max_load_weight_print: boolean = true;
    is_car_weight_print: boolean = true;
    is_bed_size_print: boolean = false;
    is_etc_print: boolean = false;

    is_index_print: boolean = true;
    is_driver_license_type_print: boolean = true;
    is_driver_license_expire_date_print: boolean = true;
    is_driver_tel_print: boolean = true;

    is_lease_fee_print: boolean = false;
    is_lease_balance_print: boolean = false;
    is_lease_disposal_print: boolean = false;
    is_lease_withdrawl_print: boolean = false;
    is_lease_start_date_print: boolean = false;
}


export class PdfPrintTarget{
    is_inspection_pdf: boolean = false;
    is_inspection_license_pdf: boolean = false;
    is_insurance_pdf: boolean = false;
    is_insurance_option_pdf: boolean = false;
    is_weight_check_pdf: boolean = false;
}


export class PdfLink{
    status: string;
    presigned_url: string;
    create_date: string;
    expired_date: Date;
}



// WEBPACK FOOTER //
// ./src/app/member-kanri/car.service.ts